module.exports = __webpack_public_path__ + "img/calendar_today.a5b49673.svg";